var map = {
	"./AxieGG.jpg": 817,
	"./AxieGG.webp": 115,
	"./CryptoSpacesNetwork.png": 482,
	"./CryptoSpacesNetwork.webp": 6,
	"./DoginalDogs.png": 131,
	"./DoginalDogs.webp": 937,
	"./InstinctiveLabs.svg": 716,
	"./KennelDAO.png": 163,
	"./KennelDAO.webp": 349,
	"./Kollector.png": 327,
	"./Kollector.webp": 9,
	"./LesCollectionneursNFT.png": 953,
	"./LesCollectionneursNFT.webp": 819,
	"./MonkeDAO.png": 842,
	"./MonkeDAO.webp": 888,
	"./MonkeyPOX.png": 210,
	"./MonkeyPOX.webp": 354,
	"./NonFungibleGaming.png": 502,
	"./NonFungibleGaming.webp": 366,
	"./PopArtCats.png": 867,
	"./PopArtCats.webp": 423,
	"./SolcietySolana.png": 970,
	"./SolcietySolana.webp": 608,
	"./SuperteamCanada.png": 686,
	"./SuperteamCanada.webp": 402,
	"./X banner-instinctive.jpg": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;